import { arrayUnion, doc, writeBatch } from "firebase/firestore";
import { getDownloadURL, ref, uploadBytes } from "firebase/storage";
import { db, storage } from "../utils/FirebaseConfig";

const extensionFor = (blob) => blob.type === "image/png" ? "png" : "jpg";

export const createPosterRepository = (dependencies) => {
    const {
        db: database,
        storage: storageInstance,
        ref: storageRef,
        uploadBytes: upload,
        getDownloadURL: downloadUrl,
        doc: documentRef,
        writeBatch: makeBatch,
        arrayUnion: appendUnique,
    } = dependencies;

    const uploadVariant = async (mosqueId, assetId, name, blob) => {
        const extension = extensionFor(blob);
        const objectRef = storageRef(
            storageInstance,
            `${mosqueId}/posters/${assetId}/${name}.${extension}`
        );
        await upload(objectRef, blob, {
            contentType: blob.type || "image/jpeg",
            cacheControl: "public,max-age=31536000,immutable",
        });
        return downloadUrl(objectRef);
    };

    const savePosterMetadata = async (mosqueId, asset) => {
        if (!mosqueId || !asset?.assetId) throw new TypeError("Poster tidak lengkap");

        const [thumbnailUrl, mediumUrl, originalUrl] = await Promise.all([
            uploadVariant(mosqueId, asset.assetId, "thumbnail", asset.thumbnail.blob),
            uploadVariant(mosqueId, asset.assetId, "medium", asset.medium.blob),
            uploadVariant(mosqueId, asset.assetId, "original", asset.original),
        ]);

        const metadata = {
            assetId: asset.assetId,
            thumbnailUrl,
            mediumUrl,
            originalUrl,
            dimensions: {
                thumbnail: { width: asset.thumbnail.width, height: asset.thumbnail.height },
                medium: { width: asset.medium.width, height: asset.medium.height },
                original: { width: asset.originalWidth, height: asset.originalHeight },
            },
            byteSizes: {
                thumbnail: asset.thumbnail.blob.size,
                medium: asset.medium.blob.size,
                original: asset.original.size,
            },
        };

        const batch = makeBatch(database);
        batch.set(documentRef(database, "masajid", mosqueId, "posters", asset.assetId), metadata);
        batch.set(
            documentRef(database, "masajid", mosqueId),
            {
                etv: { etvImage: appendUnique(mediumUrl) },
                normalizedPosterWriteId: asset.assetId,
            },
            { merge: true }
        );
        await batch.commit();
        return metadata;
    };

    return { savePosterMetadata };
};

const posterRepository = createPosterRepository({
    db,
    storage,
    ref,
    uploadBytes,
    getDownloadURL,
    doc,
    writeBatch,
    arrayUnion,
});

export const savePosterMetadata = posterRepository.savePosterMetadata;
